import { useEffect } from 'react';
import type { ReactNode } from 'react';

import { initWebApp, watchViewport } from '@/shared/lib/telegram';

interface TelegramProviderProps {
  children: ReactNode;
}

/**
 * Инициализация мини-аппа: `ready()` говорит клиенту, что можно убирать
 * прелоадер, дальше следим за вьюпортом и безопасными отступами.
 */
export function TelegramProvider({ children }: TelegramProviderProps) {
  useEffect(() => {
    initWebApp();
    return watchViewport();
  }, []);

  return children;
}
